const namespace = 'AUDITED_FINANCIALS_';

export const CONSTANTS = {
    GET_AUDITED_FINANCIALS_REPORT_ID: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID`,
    GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS`,
};

// Frozen legacy Hermes report filename — never offered as the generated report.
export const LEGACY_AUDITED_FILENAME = 'AuditedFinancials.csv';

export const AUDITED_NOT_READY_TOAST =
    "Audited financials report isn't generated yet. Refresh financials or upload audited data, then try again.";

export const AUDITED_REGENERATE_FAILED_TOAST =
    'Could not regenerate the audited financials report. Please try again.';

export const TENURE = {
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    YEARLY: 'Yearly',
} as const;

export const HEADER_TYPE = {
    AUDITED_FINANCIALS: 'audited',
    PROVISIONAL_FINANCIALS: 'provisional',
} as const;
